export const DRIVE_DONORS_DATE_FORMAT = 'MM/dd/yyyy'
export const DRIVE_DONORS_DATETIME_FORMAT = 'MM/dd/yyyy hh:mm a'

export const DRIVE_DONORS_SOURCE_TABS = {
  ACCOUNT_DONORS: 'account_donors',
  SCHEDULED_APPOINTMENTS: 'scheduled_appointments',
  DRIVE_ATTENDEES: 'drive_attendees',
}

export const DRIVE_DONORS_RECIPIENT_MODES = {
  SELECTED: 'selected',
  ALL_DONORS: 'all_donors',
  ALL_ELIGIBLE_DONORS: 'all_eligible_donors',
}

export const DRIVE_DONORS_EMAIL_MODES = {
  COMPOSED: 'composed',
  PRECONFIGURED: 'preconfigured',
}

export const DRIVE_DONORS_SELECTED_RECIPIENT_ERROR =
  'Select at least one donor to send email.'

export const hasDriveDonorsSelectedRecipients = ({
  donorIds = [],
  guestIds = [],
} = {}) => donorIds.length > 0 || guestIds.length > 0

export const DRIVE_DONORS_EMAIL_SOURCE = 'chairperson_portal'

export const DONOR_EXPORT_CONTACT_HEADERS = [
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'calling_preference', label: 'Calling Opt-In/Out' },
  { key: 'text_preference', label: 'Text Opt-In/Out' },
  { key: 'email_preference', label: 'Email Opt-In/Out' },
]

export const getDriveDonorsDeliveryCounts = recipientPreview => ({
  willReceive: Number(recipientPreview?.will_receive) || 0,
  willSkip: Number(recipientPreview?.will_skip) || 0,
})

export const getDriveDonorsSelectedCount = ({
  donorIds = [],
  guestIds = [],
} = {}) => donorIds.length + guestIds.length

export const shouldShowDriveDonorsTemplateEmailMode = composeContext =>
  Boolean(
    composeContext?.composed_campaign_id &&
    composeContext?.preconfigured_campaign_id
  )

export const getDriveDonorsTemplateModeLabel = emailMode =>
  emailMode === DRIVE_DONORS_EMAIL_MODES.PRECONFIGURED
    ? 'Preconfigured'
    : 'Composed'

export const mapDriveDonorsTemplateOptions = (
  templates = [],
  composeContext
) => {
  const showEmailMode = shouldShowDriveDonorsTemplateEmailMode(composeContext)

  return templates.map(template => ({
    id: String(template.email_id),
    name: showEmailMode
      ? `${template.name} (${getDriveDonorsTemplateModeLabel(template.email_mode)})`
      : template.name,
    emailMode: template.email_mode,
  }))
}

export const splitDriveDonorsEmailSelectionFromRows = (rows = []) => {
  const donorIds = []
  const guestIds = []

  rows.forEach(row => {
    if (row?.is_guest && row?.guest_id) {
      guestIds.push(String(row.guest_id))
      return
    }

    if (row?.donor_id) {
      donorIds.push(String(row.donor_id))
    }
  })

  return { donorIds, guestIds }
}

export const donationStatusLabel = status => {
  switch (Number(status)) {
    case 1:
      return 'Appeared'
    case 2:
      return 'Donation'
    case 3:
      return 'Donor Left'
    case 4:
      return 'Technically Unusable'
    case 5:
      return 'Deferred At Phlebotomy'
    case 6:
      return 'Post Draw Deferral'
    case 7:
      return 'Deferred Post Defer'
    default:
      return status ?? 'N/A'
  }
}

export const buildDriveDonorsPath = driveId =>
  `/chairperson/drive-donors/${driveId}`

export const buildDriveDonorsEmailComposePath = driveId =>
  `/chairperson/drive-donors/${driveId}/email/compose`

export const buildDriveDonorsEmailReviewPath = driveId =>
  `/chairperson/drive-donors/${driveId}/email/review`

export const getDriveDonorsEmailSteps = emailMode => {
  if (emailMode === DRIVE_DONORS_EMAIL_MODES.PRECONFIGURED) {
    return ['Select Donors', 'Select Template', 'Review & Send']
  }

  return ['Select Donors', 'Compose Email', 'Review & Send']
}

export const navigateToDriveDonorsEmailFlow = ({
  navigate,
  driveId,
  accountId,
  donorIds = [],
  guestIds = [],
  sourceTab,
  recipientMode = DRIVE_DONORS_RECIPIENT_MODES.SELECTED,
  driveNavState = {},
}) => {
  navigate(buildDriveDonorsEmailComposePath(driveId), {
    state: {
      ...driveNavState,
      donorIds,
      guestIds,
      sourceTab,
      recipientMode,
      accountId,
    },
  })
}

export const stripDriveDonorsEmailHtml = (html = '') =>
  html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

/** True when compose has user-entered subject or body content. */
export const hasDriveDonorsEmailDraftContent = (subject = '', emailBody = '') =>
  Boolean(subject?.trim()) || Boolean(stripDriveDonorsEmailHtml(emailBody))
